import { FC } from "react"
import { SxProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

import { VerticalCard } from "components/card/VerticalCard"
import { PromotionData } from "providers/venue/types"
export interface IVerticalPromotionCardProps {
  sx?: SxProps
  data: PromotionData
  dense?: boolean
  className?: string
}

export const VerticalPromotionCard: FC<IVerticalPromotionCardProps> = ({
  sx,
  data,
  dense = false,
  className,
}) => {
  const theme = useTheme()

  const { root } =
    theme.components?.[`VerticalPromotionCard`]?.styleOverrides || {}

  return (
    <VerticalCard
      data={data}
      dense={dense}
      sx={deepmerge(root, sx)}
      className={className}
    />
  )
}
